// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {formActions, appSelectors} from '@/store'
import type {Language} from '@/types'
import CountrySelect from '@/controls/country-select'
import {supportedCountryCodesForImport, supportedNumberType, supportedNumberTypeCoface, countryListForSafeNumbersOnly, countryListForConnectIdOnly} from '@/views/util'
import './upload-manual-form.css'
import '@/controls/portfolio-select.css'

type Props = {
  l: Language,
  storeFormField: (Object) => void,
  userCountryCode: string,
  type: string,
  onConfirm: () => void,
  collapseManualUpload: () => void,
}

const initialState = {
  selectedCountry: '',
  companyIds: '',
  isAddDisabled: true,
  supportedType: supportedNumberType[0],
  showList: false,
  disable: false,
  isCofaceCountry: false,
}

type State = {
  selectedCountry: string,
  companyIds: string,
  isAddDisabled: boolean,
  supportedType: string,
  showList: boolean,
  disable: boolean,
  isCofaceCountry: boolean,
}

export class ManualUploadForm extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {...initialState, selectedCountry: props.userCountryCode}
  }

  checkSafeNumberOnlyCountries = (country: string) => countryListForSafeNumbersOnly.includes(country)

  checkConnectIdOnlyCountries = (country: string) => countryListForConnectIdOnly.includes(country)

  onCustomSelect = (custom: string) => {
    if (custom === 'Safe Number' || custom === 'Org Number' || custom === 'Connect Id') {
      if (countryListForSafeNumbersOnly.includes(this.state.selectedCountry) && custom === 'Org Number') {
        this.setState({supportedType: 'Safe Number', disable: true, isCofaceCountry: false})
      } else if (countryListForConnectIdOnly.includes(this.state.selectedCountry)) {
        if (custom === 'Org Number') {
          this.setState({supportedType: custom, isCofaceCountry: true})
        } else {
          this.setState({supportedType: 'Connect Id', isCofaceCountry: true})
        }
      } else {
        this.setState({disable: false, isCofaceCountry: false})
      }
    } else {
      if ((this.checkSafeNumberOnlyCountries(custom) && this.state.supportedType === 'Org Number') ||
        this.checkSafeNumberOnlyCountries(custom)) {
        this.setState({selectedCountry: custom, supportedType: 'Safe Number', disable: true, isCofaceCountry: false})
      } else if (this.checkConnectIdOnlyCountries(custom)) {
        this.setState({selectedCountry: custom, supportedType: 'Connect Id', disable: false, isCofaceCountry: true})
      } else {
        if (this.state.supportedType === 'Connect Id') {
          this.setState({selectedCountry: custom, supportedType: 'Safe Number', disable: false, isCofaceCountry: false})
        } else {
          this.setState({selectedCountry: custom, disable: false, isCofaceCountry: false})
        }
      }
    }
  }
  onTextAreaChange = (e: any) => {
    let value = e.currentTarget.value
    this.setState({companyIds: value})
  }

  onImport = () => {
    this.props.storeFormField({
      manual: {
        countryCode: this.state.selectedCountry,
        companyIds: this.state.companyIds,
        supportedType: this.state.supportedType,
      },
    })
    this.props.onConfirm()
  }

  onCancel = () => {
    this.props.collapseManualUpload()
  }
  getPlaceHolderText = () => {
    return countryListForSafeNumbersOnly.indexOf(this.state.selectedCountry) > -1
      ? 'Safe Number Only' : 'Safe Number or Org Number'
  }

  render = () => {
    const getAvailableCountries = [...supportedCountryCodesForImport]
    const getSupportedNumberType = [...supportedNumberType]
    const getSupportedNumberTypeCoface = [...supportedNumberTypeCoface]
    return (
      <div className='manual-mode-container'>
        <p className='text-center'>
          {this.props.l('Select country of the companies, then add Safe number or Organisation numbers to the text area and click on import')}
        </p>
        <div className='manual-import-block'>
          <div className='col-md-8 manual-import-input-block'>
            <CountrySelect
              selected={this.state.selectedCountry || 'GB'}
              availableCountries={getAvailableCountries}
              allOption={false}
              onChange={this.onCustomSelect}
            />
            <div
              style={{
                display: 'inline-block',
              }} className={this.state.showList ? 'country-select dropdown open' : 'country-select dropdown'}
            >
              <button
                className="btn btn-default dropdown-toggle"
                type="button"
                onClick={() => {
                  this.setState((prevState) => ({
                    showList: !prevState.showList,
                  }))
                }}
                onBlur={() => {
                  this.setState({
                    showList: false,
                  })
                }}
                disabled={this.state.disable}
              >{this.state.supportedType}
                <span
                  style={{
                    marginLeft: '6px',
                  }}
                  className="caret"
                >
                </span>
              </button>
              <ul className="custom-dropdown-menu"
                style={{'display': this.state.showList ? 'block' : 'none'}}>
                {!this.state.isCofaceCountry ? getSupportedNumberType.map((selectedType, index) =>
                  <li
                    key={index}
                    onMouseDown={() => {
                      this.setState({
                        supportedType: selectedType,
                        showList: false,
                      })
                      this.onCustomSelect(selectedType)
                    }}
                  ><span>{this.props.l(selectedType)}</span>
                  </li>
                ) : getSupportedNumberTypeCoface.map((selectedType, index) =>
                  <li
                    key={index}
                    onMouseDown={() => {
                      this.setState({
                        supportedType: selectedType,
                        showList: false,
                      })
                      this.onCustomSelect(selectedType)
                    }}
                  ><span>{this.props.l(selectedType)}</span>
                  </li>
                )}
              </ul>
            </div>
            <div className='manual-import-list-box'>
              <textarea
                value={this.state.companyIds}
                onChange={this.onTextAreaChange}
                rows='10'
                cols='50'
                placeholder={this.props.l(this.state.supportedType)}
              >
              </textarea>
            </div>
          </div>
          <div className='col-md-4 manual-import-btn-block'>
            <button className='btn btn-success' disabled={!this.state.companyIds}
              onClick={this.onImport}>
              {this.props.l(this.props.type === 'import' ? 'Import' : 'Sync')}
            </button>
            <button className='btn btn-danger' onClick={this.onCancel}>{this.props.l('Cancel')}</button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  userCountryCode: state.app.user.countryCode,
})
export default connect(
  mapStateToProps,
  formActions,
)(ManualUploadForm)



// WEBPACK FOOTER //
// ./src/views/forms/upload-manual-form.js